<template>
    
        <div class="flex w-full lg:w-1/2 mx-auto flex-col relative bg-gray-800 text-white p-4 rounded-xl my-4">
            <div>
                <div class="flex justify-between mb-2"> 
                    <h4 class="text-gray-200"> {{ resource }}</h4>
                    <p class="text-gray-200">{{ City }}</p>
                </div>
                <div class="flex flex-row justify-between">
                    <h2 class="text-xl font-semibold text-blue-500">
                        <a :href="'tel:'+phone_num">{{phone_num }}</a> 
                    </h2>
                    <p class="flex gap-4">
                    <a :href="'tel:'+phone_num">
                        <svg class="fill-current hover:text-blue-300 text-blue-500" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.41969 2.64225L9.58535 2.26958C10.6795 1.92075 11.8463 2.48516 12.3154 3.588L13.2459 5.785C13.6511 6.74158 13.4269 7.86716 12.6891 8.567L10.6373 10.5148C10.7629 11.6805 11.1551 12.8277 11.8116 13.9566C12.4354 15.0488 13.272 16.0048 14.2719 16.7678L16.7364 15.9445C17.6714 15.6336 18.6886 15.9922 19.2606 16.8339L20.5964 18.7947C21.2626 19.7741 21.1434 21.1239 20.3169 21.9537L19.4307 22.8432C18.5489 23.7282 17.2889 24.05 16.1244 23.686C13.3738 22.828 10.8453 20.2811 8.53777 16.0452C6.22702 11.8029 5.41127 8.20191 6.0916 5.24658C6.3776 4.00291 7.26269 3.01166 8.41969 2.64225Z" fill=""/>
                        </svg>
                    </a>
                    <a :href="'sms:'+phone_num">
                        <svg class="fill-current hover:text-blue-300 text-blue-500" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.16669 9.74349C2.16612 8.89005 2.3339 8.04487 2.66044 7.25636C2.98697 6.46785 3.46584 5.7515 4.06962 5.14832C4.6734 4.54515 5.39023 4.067 6.17906 3.74125C6.9679 3.41551 7.81324 3.24857 8.66669 3.24999H17.3334C20.9224 3.24999 23.8334 6.16958 23.8334 9.74349V22.75H8.66669C5.07761 22.75 2.16669 19.8304 2.16669 16.2565V9.74349ZM15.1667 11.9167V14.0833H17.3334V11.9167H15.1667ZM8.66669 11.9167V14.0833H10.8334V11.9167H8.66669Z" fill=""/>
                        </svg>
                    </a>
                    </p>
                </div>
                <p class="text-base my-1"> {{ name }}</p>
                <p class="text-sm text-gray-300"> Address : {{ Address }} </p>
                <div class="flex flex-wrap justify-between gap-x-2 ">
                <p class="text-sm text-gray-400"> {{ otherinfo }} </p>
                <a class="text-sm text-gray-400" v-if="sourcelink != null" :href="sourcelink[0]">Source Link here</a>
                </div>
                <div class="w-full h-1 bg-gray-500 mt-2"></div>
            </div>
            <div class="flex justify-between mt-2">
                <div>
                <p class="text-green-300" v-if="verified === true"> Verified ✓ </p>
                <p class="text-yellow-300" v-else>Not verified</p>
                </div>
                <!-- <p class="text-gray-300">{{updated}}</p> -->
                <div class="flex gap-6">
                    <p class="flex gap-2"> {{ likes }}
                        <a class="cursor-pointer" >
                            <svg class="fill-current text-gray-400 hover:text-blue-500" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 21H5V8H4C3.46957 8 2.96086 8.21071 2.58579 8.58579C2.21071 8.96086 2 9.46957 2 10V19C2 19.5304 2.21071 20.0391 2.58579 20.4142C2.96086 20.7893 3.46957 21 4 21ZM20 8H13L14.122 4.632C14.2221 4.33141 14.2494 4.01135 14.2016 3.69815C14.1538 3.38496 14.0322 3.08761 13.847 2.83059C13.6617 2.57358 13.4181 2.36424 13.1361 2.21984C12.8541 2.07543 12.5418 2.00008 12.225 2H12L7 7.438V21H18L21.912 12.404L22 12V10C22 9.46957 21.7893 8.96086 21.4142 8.58579C21.0391 8.21071 20.5304 8 20 8Z" fill=""/>
                            </svg>
                        </a>
                    </p>
                    <p class="flex gap-2"> {{ dislikes }}
                        <a class="cursor-pointer" @click="disliked">
                           <svg class="fill-current text-gray-400 hover:text-yellow-600" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 3H19L19 16H20C20.5304 16 21.0391 15.7893 21.4142 15.4142C21.7893 15.0391 22 14.5304 22 14V5C22 4.46957 21.7893 3.96086 21.4142 3.58579C21.0391 3.21072 20.5304 3 20 3ZM4 16H11L9.878 19.368C9.77789 19.6686 9.75061 19.9887 9.79843 20.3018C9.84625 20.615 9.96778 20.9124 10.153 21.1694C10.3383 21.4264 10.5819 21.6358 10.8639 21.7802C11.1459 21.9246 11.4582 21.9999 11.775 22H12L17 16.562L17 3L6 3L2.088 11.596L2 12V14C2 14.5304 2.21072 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16Z" fill=""/>
                            </svg>
                        </a>
                    </p>
                </div>
            </div>
        </div>
    
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return{
        }
    },
    props:{
        resource : String,
        name : String,
        phone_num : {
            value: [Number, String],
            required: Boolean
        },
        likes : Number,
        dislikes : Number,
        verified : [String , Boolean  ],
        updated : String,
        City : String,
        otherinfo :String,
        sourcelink:Array,
        Address : String

    },    
    methods:{
        disliked(){
            
        }
    }
}
</script>